import { useMutation } from '@apollo/react-hooks';
import {
  RefreshTimelineEntryMutation,
  RefreshTimelineEntryMutationVariables,
} from '../../../types/__generated__';
import mutation from './queries/refreshTimelineEntry.gql';
import { MutationResult } from '@apollo/react-common';

export function useRefreshTimelineEntry(
  timelineEntryId: string,
): [Function, MutationResult] {
  const [runMutation, mutationResult] = useMutation<
    RefreshTimelineEntryMutation,
    RefreshTimelineEntryMutationVariables
  >(mutation, {
    variables: { input: { id: timelineEntryId } },
    context: {
      credentials: 'include',
    },
    errorPolicy: 'all',
  });

  return [runMutation, mutationResult];
}
